<template>
    <div class="solutionguide__breadcrumb">
        <template v-if="isMobile">
            <div class="solutionguide__step solutionguide__step--active">{{$t(activeStep+'.step')}}</div>
            <div class="solutionguide__stepcount">({{activeStepNo}}/{{totalStepCount}})</div>
        </template>
        <template v-else>
            <template v-for="(step, index) in Object.values(steps)">
                <div class="solutionguide__divider" v-if="index > 0"></div>
                <div class="solutionguide__step" @click="() => goBackToStep(step)" :class="isActiveStep(step) ? 'solutionguide__step--active' : isPreviousStep(step) ? 'solutionguide__step--prev' : ''">{{$t(step+'.step')}}</div>
            </template>
        </template>
    </div>
</template>

<script lang="ts">
    import Vue from "vue";
    import {mapGetters, mapState} from "vuex";
    import {STEP} from "../store/solutionGuideStore"

	export default Vue.extend({
        name: "breadcrumb",
        computed: {
            ...mapState(['activeStep']),
            ...mapGetters(['isMobile', 'isActiveStep', 'isPreviousStep']),
            steps() {
                return STEP
            },
            activeStepNo() {
                return Object.values(STEP).indexOf(this.activeStep) + 1
            },
            totalStepCount() {
                return Object.values(STEP).length
            }
        },
        methods: {
            goBackToStep(step: STEP) {
                this.$store.dispatch('backToStep', step)
            }
        }
    })
</script>
